import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function DriveCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = () => {
      // Get OAuth parameters from URL
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        // Redirect back to dashboard with error
        navigate('/dashboard?drive_error=' + encodeURIComponent(error), { replace: true });
        return;
      }

      if (code && state === 'drive_setup') {
        // Redirect to dashboard with code - the dashboard will handle it
        navigate('/dashboard?code=' + code + '&state=' + state, { replace: true });
        return;
      }

      if (code && state === 'settings_drive') {
        // Redirect to settings with code
        navigate('/settings?code=' + code + '&state=' + state, { replace: true });
        return;
      }

      // No valid params, redirect to dashboard
      navigate('/dashboard', { replace: true });
    };

    processCallback();
  }, [navigate, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-700 mx-auto"></div>
        <p className="mt-4 text-slate-600">Connecting Google Drive...</p>
      </div>
    </div>
  );
}

export default DriveCallback;
